import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroBanner from './components/HeroBanner';
import CategoryNav from './components/CategoryNav';
import PopularComics from './components/PopularComics';
import LatestUpdates from './components/LatestUpdates';
import Features from './components/Features';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <title>爱漫画 | 非常爱漫画免费在线看全集 | 好看的漫画大全</title>
      <meta name="description" content="非常爱漫画提供免费漫画全集在线看，支持下拉式阅读，海量好看的国漫日漫韩漫免费追更，爱漫画平台免费漫画大全随时畅读。" />
      <meta name="keywords" content="非常爱漫画, 非常爱漫画免费, 非常爱漫画在线看, 非常爱漫画全集, 爱漫画, 免费漫画, 漫画大全, 在线漫画, 下拉式漫画, 好看的漫画" />
      <link rel="canonical" href="https://www.aimanhua.com" />
      <meta property="og:title" content="爱漫画 | 非常爱漫画免费在线看全集 | 好看的漫画大全" />
      <meta property="og:description" content="非常爱漫画提供免费漫画全集在线看，支持下拉式阅读，海量好看的国漫日漫韩漫免费追更，爱漫画平台免费漫画大全随时畅读。" />
      <meta property="og:url" content="https://www.aimanhua.com" />
      <meta property="og:type" content="website" />
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "爱漫画",
          "url": "https://www.aimanhua.com",
          "description": "非常爱漫画提供免费漫画全集在线看，支持下拉式阅读，海量好看的国漫日漫韩漫免费追更。",
          "potentialAction": {
            "@type": "SearchAction",
            "target": "https://www.aimanhua.com/search?q={search_term_string}",
            "query-input": "required name=search_term_string"
          }
        })}
      </script>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "爱漫画",
          "url": "https://www.aimanhua.com",
          "description": "非常爱漫画提供免费漫画全集在线看，海量国漫日漫韩漫免费追更。"
        })}
      </script>

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroBanner />
          <CategoryNav />
          <PopularComics />
          <LatestUpdates />
          <Features />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}